const getInvoiceTitle = (type, invoiceId, title) =>
    `${type}${invoiceId ? `-${invoiceId}` : ''}${title ? `-${title}` : ''}`;

export default getInvoiceTitle;
